import SvgEntretientSuiviIcon from "@Components/CustomIcon/SvgEntretientSuiviIcon"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import VisioCallModal from "@Components/VisioCallModal/VisioCallModal"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { Ionicons } from "@expo/vector-icons"
import { useAppointmentHooks } from "../../../Hooks/useAppointmentHooks"
import { confirmAction, freeslotDateFormat, localDateFormat } from "@Utils/utils"
import moment from "moment"
import React, { useState } from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"

export const AppointmentCardItem = (props) => {
    const { startDate, id, visioContent, isVisio, setUpdateList, name } = props
    const [openVisio, setOpenVisio] = useState(false)
    const toggleVisioModal = () => setOpenVisio(!openVisio)
    const educationalDiagnosisVisio = { visioconference: visioContent }

    const handlePress = () => {
        if (visioContent?.id > 0) {
            toggleVisioModal()
        } else {
            props?.onPress?.()
        }
    }

    const { handleDeleteAppointment, deleting } = useAppointmentHooks()

    return (
        <TouchableOpacity onPress={handlePress} activeOpacity={0.6}>
            <View style={styles.content}>
                <View style={{ flexDirection: "row" }}>
                    <View style={styles.iconContainer}>
                        <SvgEntretientSuiviIcon height={27} width={27} />
                    </View>
                    <View style={styles.container}>
                        <OpenSansText fontSize={14} color={baseColors.black}>
                            {name ?? "Entretien d'évaluation"}
                        </OpenSansText>
                        <Ionicons size={20} color={baseColors.green.primary} name={"chevron-forward"} />
                    </View>
                </View>

                <Spacer height={10} />

                <OpenSansText style={{ alignSelf: "center" }} fontSize={12} color={baseColors.black}>
                    {`Date : le ${moment(startDate, freeslotDateFormat).format(localDateFormat + " à HH:mm")}`}
                </OpenSansText>

                <Spacer height={10} />

                {!isVisio && (
                    <TouchableOpacity
                        disabled={deleting}
                        onPress={() => {
                            confirmAction(
                                "Annulation d'un rendez-vous",
                                "Voulez-vous vraiment annuler ce rendez-vous ?",
                                "Non",
                                "Annuler le rdv",
                                () => handleDeleteAppointment({ appointmentId: id, setUpdateList })
                            )
                        }}
                        style={{ alignSelf: "flex-end" }}
                        activeOpacity={0.7}
                    >
                        {deleting ? (
                            <ActivityIndicator color={baseColors.green.primary} />
                        ) : (
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                color={baseColors.green.primary}
                            >
                                Annuler le rdv
                            </OpenSansText>
                        )}
                    </TouchableOpacity>
                )}
            </View>

            <VisioCallModal
                open={openVisio}
                educationalDiagnosisVisio={educationalDiagnosisVisio}
                setOpenVisio={setOpenVisio}
                toggleModal={toggleVisioModal}
            />
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingStart: 10,
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row"
    },
    iconContainer: { borderRadius: 10, padding: 10, backgroundColor: baseColors.white },
    content: { padding: 15, backgroundColor: baseColors.green.light, borderRadius: 10, marginVertical: 5 }
})
